import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { constants } from 'src/app/constants';
import {SearchService} from '../services/search.service';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  selectedEnvironment: string;
  clpURL: string;
  tokenID: string;

  constructor(private router: Router,
    private searchService: SearchService,
    private location: Location,
    private activatedRoute: ActivatedRoute) {  }

  
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) {
    if (this.loggedIn(state)) {
      return true;
    } else {
      let returnUrl = this.router.url;
      this.router.navigate(['/unauthorized'], { queryParams: { state: state.url }});
      return false;
    }
  }

  loggedIn(state): boolean {
    this.tokenID = state.url ? state.url.split("token=", 2)[1] : '';
    if (this.tokenID) {
      this.tokenID = this.tokenID.split("&",1)[0];
      constants.access_token = this.tokenID;
    }
    const token = constants.access_token;
    if (token) {
      let env = constants.APP_CONFIG[location.host] ? constants.APP_CONFIG[location.host] : 'DEV';
      let sapId = constants.SAP_ID[env.toUpperCase()];

      let baseURL = (env) ? constants.PASE_URLS[env.toUpperCase()] : constants.PASE_URLS['USR'];
      baseURL = baseURL.replace(/{SAPID}/, sapId);
      this.searchService.baseURL = baseURL;
      return true;
    }
  }
  checkLogin(url: string): boolean {
    this.tokenID = 'test';
    if (!this.tokenID) {
      window.open(this.clpURL, '_self');
      return false;
    } else {
      return true;
    }
  }
}
